<emi-filter-control (filters)="onFilter($event)"></emi-filter-control>
<div class="row ml-3 pl-3 pr-5">
  <div class="col-md-12">
    <emi-table-control [tableData]="dataInformation" (action)="onAction($event)"></emi-table-control>
  </div>
  <div class="col-md-12 mb-5 d-flex justify-content-end">
    <emi-pagination [totalPages]="totalPage" [actuallyPage]="actualPage"
      (changePage)="changePage($event)"></emi-pagination>
  </div>
</div>


<!-- Modal of details about register -->
<ng-template #mdlView>
  <emi-modal-detail-register [dataRegister]="dataRegisterSelected"
    (action)="onAction($event)"></emi-modal-detail-register>
</ng-template>

<!-- Modal of view documents of register -->
<ng-template #viewImage>

  <div class="modal-header modal-header-custom">
    <div class="flex pt-2">
      <span class="fw-bold title-modal-detail fz-14-px">
        {{ 'rollCall.lblViewRegister' | translate }}
      </span>
    </div>
    <hr class="line-h-blue-purple-dialogs">

  </div>

  <div class="row modal-row-body-total mr-3 ml-3 w-95-p max-h-80-p">
    <div class="col-md-12 max-h-100-p justify-all-center top-margin-align-start scroll-panel">
      <!--View image-->
      <ng-container *ngIf="dataSelected && dataSelected.event == 'viewFile'">
        <ng-container *ngIf="dataSelected.data.type == 'selfie' || dataSelected.data.type == 'evidence'">
          <img alt="file object" class="w-100" mat-card-image [src]="dataSelected.data.url || ''" />
        </ng-container>

        <ng-container *ngIf="dataSelected.data.type == 'document'">
          <object width="100%" height="500px" [attr.data]="dataSelected.data.url" type="application/pdf">

          </object>
        </ng-container>

      </ng-container>




      <!--View mapa-->
      <ng-container *ngIf="dataSelected && dataSelected.event == 'viewLocation'">
        <div class="row w-100">
          <div class="col-md-12 w-100">
            <emi-map [name]="'Persona'" [lat]="dataSelected.data.latitude" [long]="dataSelected.data.longitude"
              [hight]="'500px'"></emi-map>
          </div>
        </div>
      </ng-container>

    </div>

    <div class="modal-footer z-index-9999">
      <div class="row w-100-p justify-content-space-between">
        <div class="col-lg-9 col-md-9 col-sm-12"></div>
        <div class="col-lg-3 col-md-3 col-sm-12 flex">
          <button class="btn btn-secondary" data-dismiss="modal" (click)="closeModalImage()">
            {{'common.btnClose' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<!-- Modal of filters -->
<ng-template #mdlFilterData>
  <div class="modal-body scroll-panel w-100-p h-adjust-px">
    <div class="row mt-3">
      <div class="col-sm-12">
        <h1 class="lblTitle-03">
          {{ 'rollCall.filterSection.lblAdvancedSearch' | translate }}
        </h1>
        <div class="line-h-blue-purple-dialogs mt-2 mb-3"></div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <span class="fw-search-instructions">
          {{ 'rollCall.filterSection.lblInstructions' | translate }}
        </span>
      </div>
    </div>
    <hr>
    <form [formGroup]="form">
      <div class="row mt-4">
        <div class="col-lg-12">
          <div class="row">
            <mat-form-field class="" appearance="outline">
              <mat-label> {{ 'rollCall.filterSection.name' | translate }}</mat-label>
              <input matInput aria-label="User" [matAutocomplete]="auto" [formControl]="userCtrl">
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelected($event)">
                <mat-option *ngFor="let user of filteredUsers | async" [value]="user" [id]="user.id">
                  <span>{{user.description}}</span> -
                  <span>{{user.name}}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>

        <div class="col-lg-6">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>
              {{ 'rollCall.filterSection.lblCreationDate' | translate }}
            </mat-label>
            <mat-date-range-input [rangePicker]="txtFechaAlta">
              <input matStartDate placeholder="Fecha inicio" formControlName="dateStart">
              <input matEndDate placeholder="Fecha fin" formControlName="dateEnd" id="txtDateEnd">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="txtFechaAlta"></mat-datepicker-toggle>
            <mat-date-range-picker #txtFechaAlta>
            </mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>
              {{ 'rollCall.filterSection.lblStatus' | translate }}
            </mat-label>
            <mat-select formControlName="status">
              <mat-option *ngFor="let item of statusCatalog" value="{{item.value}}">{{item.label}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>


    <div class="row mt-3">
      <div class="col-lg-12 scroll-y-panel" style="max-height: 400px;">
        <div *ngFor="let user of this._usersSelected">
          <div class="row mb-2">
            <div class="col-lg-2 bg-light">
              <span>{{user.description}}</span>
            </div>
            <div class="col-lg-6 bg-light">
              <span>{{user.name}}</span>
            </div>
            <div class="col-lg-1  text-center bg-light">
              <button type="button" class="btn-none" (click)="removeUser(user)">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary " data-dismiss="modal" (click)="onClose()">
      {{ 'common.btnCancel' | translate }}
    </button>
    <button class="btn btn-info " type="submit" (click)="onSearch()"
      [disabled]="form.invalid || this._usersSelected.length == 0">
      <i class="fas fa-search"></i>
      {{ 'common.btnSearch' | translate }}
    </button>
  </div>
</ng-template>